import {getBearerCredentials, getSimpleCredentials, isOpenidLogin} from '../proto/core/loginProps';
import {selectCompanyStore} from '../../features/SelectCompanyDlg/SelectCompanyStore';

export const getAuthorizationHeader = () => {
    if (isOpenidLogin()) {
        const data = getBearerCredentials();
        return 'Bearer ' + (data.Openid?.Token || '');
    }

    const data = getSimpleCredentials();

    if (!data.Simple?.Userlogin || !data.Simple?.Password) {
        throw new Error('Missing credentials');
    }
    return 'Basic ' + btoa(encodeURIComponent(`${data.Simple.Userlogin}:${data.Simple.Password}`));
};

export const getPostRequestOptions = data => ({
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        Prettyname: selectCompanyStore?.getPrettyName(),
        Authorization: getAuthorizationHeader()
    },
    body: JSON.stringify(data)
});

export const getBaseURL = () => {
    const { host = '', protocol } = window.location;

    const localAndAWSHosts = [
        'localhost',
        'priority-connect.online',
    ];

    const devHosts = [
        'dev.eshbel.com',
    ];

    const stageHosts = [
        'erpdevhe02.ceshbel.co.il',
    ];

    if (localAndAWSHosts.some(h => host.includes(h))) {
        return `${protocol}//${host}`;
    }

    if (devHosts.some(h => host.includes(h))) {
        return 'https://d.priority-connect.online';
    }

    if (stageHosts.some(h => host.includes(h))) {
        return 'https://s.priority-connect.online';
    }

    // onprem
    return 'https://p.priority-connect.online';
};

export const getAppPrefix = (): string => {
    const defaultPrefix = 'devel';
    if (typeof window === 'undefined') return defaultPrefix;
    // Try-catch will only be used for non-web apps
    try {
        const parts = window.location.pathname.split('/').filter(Boolean);
        return parts[1] || defaultPrefix; // defaultPrefix is for localhost
    } catch {
        console.log('APPLYING DEFAULT PREFIX. Window is not accessible');
        return defaultPrefix;
    }
};
